<template>
  <div>
    <!-- banner -->
    <div class="banner_w3lspvt position-relative">
      <div class="container container1500">
        <div class="d-md-flex">
          <div class="w3ls_banner_txt">
            <div class="w3ls_banner_txt">
              <h3 class="w3ls_pvt-title" v-html="$t('index.first.title')"></h3>
              <!-- <div class="btn button-style mt-md-5 mt-4" id="applyUse" @click="openDialog">联系我们</div> -->
              <a class="btn button-style mt-4" @click="skipContact">{{
                $t("index.first.contactBtn")
              }}</a>
            </div>
          </div>
          <div class="banner-img">
            <img
              src="@/assets/images/banner.png"
              alt=""
              class="img-fluid"
              v-if="lang === 'zh'"
            />
            <img
              src="@/assets/images/banner_en.png"
              alt=""
              class="img-fluid"
              v-else-if="lang === 'en'"
            />
          </div>
        </div>
      </div>
      <!-- animations effects -->
      <div class="icon-effects-w3l">
        <img
          src="@/assets/images/shape1.png"
          alt=""
          class="img-fluid shape-wthree shape-w3-one"
        />
        <img
          src="@/assets/images/shape2.png"
          alt=""
          class="img-fluid shape-wthree shape-w3-two"
        />
        <img
          src="@/assets/images/shape3.png"
          alt=""
          class="img-fluid shape-wthree shape-w3-three"
        />
        <img
          src="@/assets/images/shape5.png"
          alt=""
          class="img-fluid shape-wthree shape-w3-four"
        />
        <img
          src="@/assets/images/shape4.png"
          alt=""
          class="img-fluid shape-wthree shape-w3-five"
        />
        <img
          src="@/assets/images/shape6.png"
          alt=""
          class="img-fluid shape-wthree shape-w3-six"
        />
      </div>
      <!-- //animations effects -->
    </div>
    <!-- //banner -->
  </div>
</template>

<script>
export default {
    name: 'firstBlock',
    data() {
        return {
            lang: localStorage.getItem("lang") || "en"
        };
    },
    methods: {
        skipContact() {
            this.$router.push({
                path: "/Contact-Us"
            });
        }
    }
    
};
</script>

<style lang="scss" scoped></style>
